import React from "react";

import logoSmall from "../../layout/assets/logo_small.png";
import logoBig from "../../layout/assets/logo_big.png";
import resume from "../../layout/assets/CV_Dallas_Hermanson_2023.pdf";

import "./styles/Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__logo-box">
        <a
          href={resume}
          download="CV_Dallas_Hermanson_2023"
          rel="noopener noreferrer"
        >
          <img
            srcSet={`${logoSmall} 75w, ${logoBig} 400w`}
            sizes="(max-width: 900px) 8vw, (max-width: 600px) 12vw, (max-width: 400) 20vw"
            alt="Dallas Hermanson Full Stack Developer"
            className="footer__logo"
            src={logoSmall}
          />
        </a>
      </div>
      <div className="footer__copyright">
        Copyright &copy; {new Date().getFullYear()} by Dallas Hermanson
      </div>
    </footer>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/sections/Section-Footer/Footer.js